<!--反馈报备处理结果-->
<template>
    <div class="feedbackResult">
        <van-nav-bar
            title="反馈处理结果"
            left-arrow
            @click-left="onClickLeft"
        >
            <template #right>
                <span v-if="canEdit" class="submitResult" @click="submitResult">提交</span>
            </template>
        </van-nav-bar>
        <h2 class="title">
            <i class="iconfont icondanjubianhao"></i>反馈资料
        </h2>
        <div class="video-img-list">
            <van-uploader
                v-model="fileList"
                preview-image
                preview-full-image
                multiple
                :max-count="10"
                :max-size="10000 * 1024"
                @oversize="onOversize"
                @delete="handleFileDelete"
                upload-icon="plus"
                :deletable="canEdit"
                :show-upload="canEdit"
            ></van-uploader>
        </div>
        <h2 class="title">
            <i class="iconfont icondingdanqueren"></i>反馈结果
        </h2>
        <div class="edit-input">
            <van-field
                v-model="result"
                rows="4"
                autosize
                label=""
                type="textarea"
                maxlength="300"
                placeholder="请输入处理结果信息"
                show-word-limit
                :readonly="!canEdit"
            >
                <template slot="left-icon">
                    <i class="iconfont iconyijian"></i>
                </template>
            </van-field>
        </div>
    </div>
</template>

<script>
import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';
export default {
    name: 'feedback-result',
    mixins: [mixin_fileUpload],
    data() {
        return {
            Id: '',
            result: '',
            leadfilepath: '',

            // uploadBusinessTypeCode: 'ProductionAffix',
            fileDataId: '',

            canEdit: true,
        };
    },
    created() {
        this.canEdit = this.$route.params.canEdit;
        this.Id = this.$route.params.data.Id;
        this.fileDataId = this.Id;
        this.result = this.$route.params.data.result;
        this.leadfilepath = this.$route.params.data.leadfilepath;
        if (this.leadfilepath) {
            this.loadExistingFiles(this.leadfilepath);
        }
    },
    mounted() {
    },
    methods: {
        // 提交结果
        async submitResult() {
            this.$toast.loading();
            await this.saveFile();
            const submitUrl = '/interfaceApi/logistics/car_feedback/update_carfeedbackresult?id=' + this.Id
            + '&reslut=' + this.result + '&iscar=0&leadfilepath=' + this.leadfilepath;
            this.$axios.post(submitUrl)
                .then(() => {
                    this.$toast.clear();
                    this.$toast.success('提交成功');
                    this.onClickLeft();
                }).catch(error => {
                    this.$toast.clear();
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 加载已有文件到fileList（支持新旧格式ID兼容）
        loadExistingFiles(filepath) {
            const fileIds = filepath.split(',').filter(Boolean);
            fileIds.forEach(fileId => {
                this.fileList.push({
                    url: `${this.GLOBAL.FILE_BASE_URL}file-manage/${fileId}/download`,
                    FileID: fileId,
                    isImage: true,
                    status: 'done',
                });
            });
        },
        // 编辑保存文件（保存时上传，使用mixin的uploadSingleFile）
        async saveFile() {
            const fileIds = [];
            for (const item of this.fileList) {
                if (item.file) {
                    try {
                        const firmRes = await this.uploadSingleFile(item);
                        if (firmRes && firmRes.FileID) {
                            fileIds.push(firmRes.FileID);
                        }
                    } catch (e) {
                        this.$toast(e?.ErrorCode?.Message || '上传失败');
                    }
                } else if (item.FileID) {
                    fileIds.push(item.FileID);
                } else if (item.id) {
                    fileIds.push(item.id);
                }
            }
            this.leadfilepath = fileIds.join(',');
        },
        // 删除文件
        handleFileDelete(file) {
            if (file.AFI_Code) {
                this.deleteFile(file);
            } else if (file.FileID) {
                this.$axios.delete(`${this.GLOBAL.FILE_BASE_URL}file-manage/${file.FileID}`);
            }
        },
        onOversize() {
            this.$toast.fail('文件大小不能超过10mb');
        },
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="stylus" scoped>
    .feedbackResult{
        .submitResult{
            color #fff;
            font-size 14rpx;
        }
        .title{
            display flex
            align-items center
            height 48rpx;
            padding-left 13rpx;
            font-size 18rpx;
            color #3495FB
            .iconfont{
                margin-right 7rpx;
            }
            &.baseInfo-title{
                border-bottom: 1px solid #ebedf0;
            }
        }
        .video-img-list{
            padding 0 10rpx;
        }
        .edit-input{
            padding 0 15rpx;
            .van-cell{
                border-radius: 4rpx;
                border: 1px solid #D7D7D7;
                .iconyijian{
                    font-size 16rpx;
                    color #979EA7
                    margin-right 10rpx;
                }
            }
        }
    }
</style>
